<script>
    import { executeClient } from 'api/rage'
    import { onMount } from 'svelte'

    const categories = [
        { type: "all",      name: 'Основные' },
        { type: "vehicle",  name: 'Транспорт' },
        { type: "fast",     name: 'Быстрый доступ' },
        { type: "fraction", name: 'Фракционные' },
        { type: "other",    name: 'Разное' },
        { type: "admin",    name: 'Для администрации' },
    ];

    let activeCat = "all";
    let list = [];
    let capturingIndex = -1;
    let isAdmin = false;

    // Раздел "Для администрации" виден только админам
    $: visibleCats = categories.filter(c => c.type !== 'admin' || isAdmin);

    // Переиспользуем существующий протокол биндера (client:binder + window.binder.*),
    // рисуем под стиль F2 (тёмные строки .settingblockr как остальные вкладки настроек).
    const installHandlers = () => {
        window.binder = {
            admin: (value) => {
                isAdmin = (value === true || value === 'true' || value === 1);
                if (!isAdmin && activeCat === 'admin') loadCat('all');
            },
            setData: (value) => { list = JSON.parse(value); capturingIndex = -1; },
            setBindData: () => {},
            updateData: (index, name) => {
                list = list.map(i => i.index === index ? { ...i, name } : i);
                capturingIndex = -1;
            },
            index: () => { capturingIndex = -1; }
        };
    };

    const loadCat = (type) => {
        activeCat = type;
        capturingIndex = -1;
        installHandlers();
        executeClient("client:binder", "get", type);
    };

    const rebind = (index) => {
        capturingIndex = index;
        executeClient("client:binder", "update", index);
    };

    // Запасной путь для колеса/боковых, если CEF всё-таки отдаёт событие странице
    // (основной путь — опрос в игре: bind.js ловит их при открытом меню).
    // Коды как у Windows: 4 — колесо, 5 — боковая «назад», 6 — боковая «вперёд».
    const MOUSE_VK = { 1: 4, 3: 5, 4: 6 };

    const onMouse = (event) => {
        if (capturingIndex === -1) return;
        const vk = MOUSE_VK[event.button];
        if (!vk) return;                       // ЛКМ/ПКМ оставляем интерфейсу
        event.preventDefault();
        event.stopPropagation();
        const index = capturingIndex;
        capturingIndex = -1;
        executeClient("client:binder", "key", index, vk);
    };

    // отмена по Esc, чтобы режим ожидания не залипал
    const onKey = (event) => {
        if (capturingIndex === -1) return;
        if (event.keyCode === 27) capturingIndex = -1;
    };

    const resetCat = () => {
        executeClient("client:binder", "refresh", activeCat);
    };

    onMount(() => loadCat("all"));
</script>

<svelte:window on:mousedown={onMouse} on:auxclick={onMouse} on:contextmenu={onMouse} on:keydown={onKey} />

<div class="binds2">
    <div class="binds2__cats">
        {#each visibleCats as c}
            <div class="binds2__cat" class:active={activeCat === c.type} on:keypress={() => {}} on:click={() => loadCat(c.type)}>{c.name}</div>
        {/each}
        <div class="binds2__reset" on:keypress={() => {}} on:click={resetCat}>Сбросить</div>
    </div>

    <div class="binds2__hint">Нажмите на клавишу справа, затем нужную кнопку — на клавиатуре (включая нумпад), колесо мыши или боковую кнопку. Esc — отмена.</div>

    {#each list as item (item.index)}
        <div class="settingblockr">
            <p>{item.title}</p>
            <div class="binds2__key" class:capturing={capturingIndex === item.index} on:keypress={() => {}} on:click={() => rebind(item.index)}>
                {capturingIndex === item.index ? 'Нажмите клавишу…' : (item.name && item.name.length ? item.name : '—')}
            </div>
        </div>
    {/each}
</div>

<style>
    .binds2 {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .binds2__cats {
        width: 90%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 0.5vh;
        margin-bottom: 1vh;
    }
    .binds2__cat {
        padding: 0.8vh 1.4vh;
        font-size: 1.3vh;
        font-family: 'SF Pro Display';
        border-radius: 0.3704vh;
        background: rgb(16, 16, 16);
        color: rgba(255, 255, 255, 0.6);
        cursor: pointer;
        transition: all .15s ease;
    }
    .binds2__cat:hover {
        background: rgb(14, 14, 14);
        color: #fff;
    }
    .binds2__cat.active {
        background: rgb(14, 14, 14);
        color: #fff;
        font-weight: 600;
    }
    .binds2__reset {
        margin-left: auto;
        padding: 0.8vh 1.4vh;
        font-size: 1.3vh;
        font-family: 'SF Pro Display';
        border-radius: 0.3704vh;
        background: rgba(253, 33, 61, 0.12);
        border: 1px solid rgba(253, 33, 61, 0.4);
        color: #ff6076;
        cursor: pointer;
        transition: all .15s ease;
        white-space: nowrap;
    }
    .binds2__reset:hover {
        background: rgba(253, 33, 61, 0.22);
        color: #fff;
    }
    .binds2__hint {
        width: 90%;
        font-size: 1.1vh;
        color: rgba(255, 255, 255, 0.4);
        margin-bottom: 1vh;
        font-family: 'SF Pro Display';
    }
    .binds2__key {
        min-width: 16vh;
        text-align: center;
        margin-right: 1.8519vh;
        padding: 0.7vh 1.2vh;
        font-size: 1.3vh;
        font-weight: 600;
        font-family: 'SF Pro Display';
        border-radius: 0.3704vh;
        background: rgba(255, 255, 255, 0.06);
        border: 1px solid rgba(255, 255, 255, 0.15);
        color: #fff;
        cursor: pointer;
        transition: all .15s ease;
        text-transform: uppercase;
    }
    .binds2__key:hover {
        background: rgba(255, 255, 255, 0.14);
    }
    .binds2__key.capturing {
        background: rgba(43, 182, 168, 0.18);
        border-color: #2BB6A8;
        color: #2BB6A8;
        text-transform: none;
    }
</style>
